import React from 'react';
import Api, { role } from '../../api/Api.js';
import MonitorEndpoints from '../../api/MonitorEndpoints';
import Loading from '../../components/Loading/Loading';
import { dangerCardHeader, successCardHeader } from "assets/jss/material-dashboard-pro-react.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { ButtonBase } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid } from '@fortawesome/free-brands-svg-icons';
import AddAndroidAppDialog from './Dialogs/AddAndroidAppDialog';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

const defaultAddApp = {
    bundle_identifier: 'com.cellfind.',
    app_name: '',
    email_apps: [],
    image: null
};

export default class GooglePlay extends React.Component {

    state = {
        apps: [],
        loading: true,
        error: false,
        addOpen: false,
        add_app: { ...defaultAddApp }
    }

    componentDidMount() {
        Api.get(MonitorEndpoints.googlePlay)
            .then(({ data }) => {
                this.setState({ apps: data, loading: false })
            })
            .catch((e) => {
                console.error(e);
                this.setState({ error: false, loading: false })
            });
    }

    addChange(newState) {
        this.setState({ add_app: { ...this.state.add_app, ...newState } })
    }

    addApp(newApp) {
        this.setState({
            apps: this.state.apps.concat([newApp]),
            add_app: {
                ...defaultAddApp
            }
        })
    }

    renderLoading() {
        return (
            <Loading>
                <div>Loading Apps...</div>
            </Loading>
        );
    }

    renderError() {
        return (
            <div>
                Error while loading apps...
            </div>
        );
    }

    renderApps() {
        return (
            <GridContainer>
                {
                    this.state.apps.map(
                        app =>
                            <GridItem xs={6} sm={4} md={3}>
                                <ButtonBase
                                    key={app.bundle_identifier}
                                    href={`https://play.google.com/store/apps/details?id=${app.bundle_identifier}`}
                                    component="a"
                                    style={{
                                        ...(app.is_live ? successCardHeader : dangerCardHeader),
                                        color: '#fff',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        padding: 20,
                                        borderRadius: 6,
                                        marginBottom: 20
                                    }}
                                >
                                    <div>
                                        {
                                            app.image ?
                                                // <FontAwesomeIcon icon={faAndroid} size="3x" />
                                                <img height="43" src={`/api/image/get?id=${app.image}`} style={{ boxShadow: '0px 5px 20px -6px rgba(0,0,0,0.49)' }} alt={`${app.app_name} App Icon`} />
                                                :
                                                <FontAwesomeIcon icon={faAndroid} size="3x" />
                                        }
                                    </div>
                                    <div style={{ flex: 1, paddingLeft: 20, paddingRight: 20, textAlign: 'left' }}>
                                        <span style={{ fontSize: 19, fontWeight: '500' }}>{app.app_name}</span><br />
                                        <span style={{ fontSize: 17 }}>{app.is_live ? "Live" : "Removed"}</span>
                                    </div>
                                </ButtonBase>
                            </GridItem>
                    )
                }
            </GridContainer>
        )
    }

    render() {
        if (this.state.loading) {
            return this.renderLoading();
        } else if (this.state.error) {
            return this.renderError();
        } else {
            return (
                <>
                    {this.renderApps()}
                    {
                        role.toLowerCase() === "admin" ?
                            <>
                                <Fab key="fab" onClick={() => this.setState({ addOpen: true })} style={{ position: 'fixed', right: 12, top: 64 }} color="secondary" aria-label="Add">
                                    <AddIcon />
                                </Fab>

                                <AddAndroidAppDialog
                                    {...this.state.add_app}
                                    isOpen={this.state.addOpen}
                                    onClose={() => this.setState({ addOpen: false })}
                                    onSubmit={this.addApp.bind(this)}
                                    onChange={this.addChange.bind(this)}
                                />
                            </>
                            : null
                    }
                </>
            );
        }
        return (
            <div>
                {/* Admins - May add apps */}
                {/* Others may only view*/}
            </div>
        );
    }
}